// @ts-nocheck
import {
  cleanHeaderText,
  normalizeHeaderToken,
} from '../settlementSheetConfig.js';

const COMMON_FIELD_ALIASES = {
  accountName: [
    '거래처명',
    '거래처',
    '협력사',
    '업체명',
    '법인명',
    '대표도매상명',
    'cso관리업체',
    '판촉대행처명',
  ],
  hospitalName: [
    '병의원명',
    '처방처명',
    '요양기관명',
    '판매처명',
    'yjp거래처명',
  ],
  drugCode: [
    '제품코드',
    '보험코드',
    '품목코드',
    '청구코드',
    'edi코드',
    '제품code',
    '처방code',
    '자재코드',
  ],
  drugName: [
    '의약품명',
    '제품명',
    '품목명',
    '품명',
    '제품',
    '자재명',
    'edi품목명',
  ],
  feeRate: [
    '정산수수료',
    '정산율',
    '수수료율vat포함',
    '수수료율v',
    '수수료율',
    '수수료%',
    '지급요율',
    '지급%',
    '합계%',
    '수수료지급율',
    '담당수수료율',
    '흡수율',
    '%',
  ],
  quantity: ['판매수량', '승인수량', '당월수량', '검수수량', '수량', '실적'],
  unitPrice: ['보험약가', '기준가', '단가', '약가', '보험가'],
  prescriptionAmount: [
    '처방금액',
    '처방액',
    '당월금액',
    '합계금액',
    '매출액',
    '금액v+',
    'edi금액',
    '청구실적',
    '보험가',
    '금액',
  ],
  settlementAmount: [
    '정산금액',
    '정산지급',
    '산출금액',
    '수수료금액',
    '지급수수료',
    '확정액',
    '거래처실지급금액',
    '수수료계',
    '수수료합계',
    '수수료',
  ],
  note: ['비고', '비고(해당월)', '정산보류사유', '정산보류 사유', '사유'],
  pharmaceuticalCompanyName: ['제약사명', '제약회사', '제조사'],
};

const PHARMACEUTICAL_COMPANY_VALUE_MAP = {
  ALCMT: '알리코제약',
  '(주)경보제약': '경보제약',
  '(주)마더스제약': '마더스제약',
  '(주)셀트리온제약': '셀트리온제약',
  '휴온스(10만미만X)': '휴온스',
};

const SUMMARY_PATTERNS = [
  /총합계/,
  /소계/,
  /합계/,
  /정산내역서/,
  /세금계산서/,
  /공급가액/,
  /부가세/,
  /요약/,
  /처방계/,
  /계】/,
  /계\]/,
  /^계$/,
];

function normalizeHeader(value) {
  return normalizeHeaderToken(value);
}

function cleanText(value) {
  return cleanHeaderText(value);
}

function parseNumber(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const normalized = String(value)
    .replace(/,/g, '')
    .replace(/원/g, '')
    .replace(/%/g, '')
    .trim();

  if (!normalized) return null;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

function normalizeRate(value) {
  const parsed = parseNumber(value);
  if (parsed == null) return null;

  const percent = parsed > 0 && parsed <= 1.2 ? parsed * 100 : parsed;
  return Number(percent.toFixed(2));
}

function roundAmount(value) {
  if (value == null || !Number.isFinite(value)) return null;
  return Number(value.toFixed(2));
}

function getFileExtension(fileName) {
  const match = String(fileName || '').match(/(\.[^.]+)$/);
  return match ? match[1].toLowerCase() : '';
}

function getBaseFileName(fileName) {
  return String(fileName || '').replace(/\.[^.]+$/, '');
}

function guessPharmaceuticalCompanyName(fileName) {
  let baseName = getBaseFileName(fileName);

  baseName = baseName.replace(/^\d+[_\s-]*/, '');

  if (baseName.includes('루다메디스트림-')) {
    baseName = baseName.split('루다메디스트림-')[1];
  }

  if (baseName.includes('-루다메디스트림')) {
    baseName = baseName.split('-루다메디스트림')[0];
  }

  const token = baseName.split('_')[0] || baseName;

  return token
    .replace(/\(.*?\)/g, '')
    .replace(/주식회사/g, '')
    .replace(/㈜/g, '')
    .replace(/루다메디스트림/g, '')
    .replace(/\d{2,4}년.*$/, '')
    .replace(/\d{2,4}[./-]?\d{1,2}.*$/, '')
    .replace(/\d+월.*$/, '')
    .replace(/정산.*$/, '')
    .replace(/처방자료.*$/, '')
    .replace(/실적.*$/, '')
    .replace(/지급.*$/, '')
    .replace(/종합.*$/, '')
    .replace(/전송.*$/, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function normalizePharmaceuticalCompanyName(
  value,
  detectedPharmaceuticalCompany,
) {
  const cleanedValue = cleanText(value);
  if (!cleanedValue) {
    return detectedPharmaceuticalCompany || '';
  }

  if (PHARMACEUTICAL_COMPANY_VALUE_MAP[cleanedValue]) {
    return PHARMACEUTICAL_COMPANY_VALUE_MAP[cleanedValue];
  }

  const simplifiedValue = cleanedValue
    .replace(/주식회사/g, '')
    .replace(/㈜/g, '')
    .replace(/\(주\)/g, '')
    .replace(/\(10만미만X\)/g, '')
    .replace(/^[△▲▶▷◆■□●○★☆※•·\s]+/, '')
    .replace(/\s+/g, ' ')
    .trim();

  if (!simplifiedValue) {
    return detectedPharmaceuticalCompany || '';
  }

  if (/^[A-Z]{4,}$/.test(simplifiedValue) && detectedPharmaceuticalCompany) {
    return detectedPharmaceuticalCompany;
  }

  if (simplifiedValue.includes('휴온스')) {
    return '휴온스';
  }

  return simplifiedValue;
}

function buildNormalizedAliases(fieldAliases = {}) {
  return Object.fromEntries(
    Object.entries(fieldAliases).map(([key, aliases]) => [
      key,
      aliases
        .map((alias) => normalizeHeader(alias))
        .sort((left, right) => right.length - left.length),
    ]),
  );
}

function getBestHeaderMatch(normalizedCell, normalizedAliases) {
  let bestMatch = null;

  Object.entries(normalizedAliases).forEach(([field, aliases]) => {
    aliases.forEach((alias) => {
      if (!alias) return;
      if (normalizedCell !== alias) return;

      if (!bestMatch || alias.length > bestMatch.alias.length) {
        bestMatch = { field, alias };
      }
    });
  });

  return bestMatch;
}

function buildColumnMap(row = [], normalizedAliases) {
  const columnMap = {};

  row.forEach((cell, columnIndex) => {
    const normalizedCell = normalizeHeader(cell);
    if (!normalizedCell) return;

    const match = getBestHeaderMatch(normalizedCell, normalizedAliases);
    if (!match) return;

    if (columnMap[match.field] == null) {
      columnMap[match.field] = columnIndex;
    }
  });

  return columnMap;
}

function findHeaderRowIndex(rows = [], normalizedAliases) {
  let bestMatch = { index: -1, score: 0, columnMap: {} };

  rows.slice(0, 40).forEach((row, rowIndex) => {
    const columnMap = buildColumnMap(row, normalizedAliases);
    const keys = Object.keys(columnMap);
    if (keys.length === 0) return;

    let score = keys.length;
    if (columnMap.drugName != null) score += 2;
    if (columnMap.hospitalName != null || columnMap.accountName != null) {
      score += 1;
    }
    if (
      columnMap.prescriptionAmount != null ||
      columnMap.settlementAmount != null
    ) {
      score += 1;
    }

    if (score > bestMatch.score) {
      bestMatch = { index: rowIndex, score, columnMap };
    }
  });

  return bestMatch.score >= 4
    ? bestMatch
    : { index: -1, score: 0, columnMap: {} };
}

function getCellValue(row, columnMap, key) {
  const columnIndex = columnMap[key];
  return columnIndex == null ? null : row[columnIndex];
}

function isSummaryLikeText(value) {
  const text = cleanText(value);
  if (!text) return false;
  return SUMMARY_PATTERNS.some((pattern) => pattern.test(text));
}

function shouldSkipRecord(record, rawRow = []) {
  const joinedRow = rawRow.map(cleanText).filter(Boolean).join(' ');
  const hasDetailIdentity = Boolean(record.drugName || record.drugCode);
  const hasCounterparty = Boolean(record.customerName);
  const hasAmounts =
    record.prescriptionAmount != null || record.settlementAmount != null;

  if (!hasDetailIdentity && !hasCounterparty) {
    return true;
  }

  if (
    record.customerName &&
    isSummaryLikeText(record.customerName) &&
    !hasDetailIdentity
  ) {
    return true;
  }

  if (record.drugName && isSummaryLikeText(record.drugName)) {
    return true;
  }

  if (!hasDetailIdentity && !hasAmounts) {
    return true;
  }

  if (
    !hasDetailIdentity &&
    joinedRow &&
    SUMMARY_PATTERNS.some((pattern) => pattern.test(joinedRow))
  ) {
    return true;
  }

  return false;
}

function buildStandardRecord({
  fileName,
  sheetName,
  rowIndex,
  templateId = 'default',
  detectedPharmaceuticalCompany,
  rowPharmaceuticalCompanyName,
  hospitalName,
  accountName,
  customerName,
  drugCode,
  drugName,
  feeRateValue,
  quantityValue,
  unitPriceValue,
  prescriptionAmountValue,
  settlementAmountValue,
  note,
}) {
  const resolvedHospitalName = cleanText(hospitalName);
  const resolvedAccountName = cleanText(accountName);
  const resolvedCustomerName =
    cleanText(customerName) ||
    resolvedHospitalName ||
    resolvedAccountName ||
    '';
  const resolvedCompanyName = normalizePharmaceuticalCompanyName(
    rowPharmaceuticalCompanyName ||
      detectedPharmaceuticalCompany ||
      guessPharmaceuticalCompanyName(fileName),
    detectedPharmaceuticalCompany,
  );

  const record = {
    id: `${fileName}-${sheetName}-${rowIndex + 1}`,
    templateId,
    sourceFileName: fileName,
    sourceSheetName: sheetName,
    pharmaceuticalCompanyName: resolvedCompanyName,
    customerName: resolvedCustomerName,
    drugCode: cleanText(drugCode),
    drugName: cleanText(drugName),
    feeRatePercent: normalizeRate(feeRateValue),
    quantity: roundAmount(parseNumber(quantityValue)),
    unitPrice: roundAmount(parseNumber(unitPriceValue)),
    prescriptionAmount: roundAmount(parseNumber(prescriptionAmountValue)),
    settlementAmount: roundAmount(parseNumber(settlementAmountValue)),
    note: cleanText(note),
  };

  if (
    record.prescriptionAmount == null &&
    record.unitPrice != null &&
    record.quantity != null
  ) {
    record.prescriptionAmount = roundAmount(record.unitPrice * record.quantity);
  }

  if (
    record.settlementAmount == null &&
    record.prescriptionAmount != null &&
    record.feeRatePercent != null
  ) {
    record.settlementAmount = roundAmount(
      (record.prescriptionAmount * record.feeRatePercent) / 100,
    );
  }

  if (
    record.feeRatePercent == null &&
    record.prescriptionAmount &&
    record.settlementAmount != null
  ) {
    record.feeRatePercent = roundAmount(
      (record.settlementAmount / record.prescriptionAmount) * 100,
    );
  }

  return record;
}

function buildRecordFromColumnMap({
  row,
  columnMap,
  fileName,
  sheetName,
  rowIndex,
  templateId,
  detectedPharmaceuticalCompany,
}) {
  return buildStandardRecord({
    fileName,
    sheetName,
    rowIndex,
    templateId,
    detectedPharmaceuticalCompany,
    rowPharmaceuticalCompanyName: getCellValue(
      row,
      columnMap,
      'pharmaceuticalCompanyName',
    ),
    hospitalName: getCellValue(row, columnMap, 'hospitalName'),
    accountName: getCellValue(row, columnMap, 'accountName'),
    drugCode: getCellValue(row, columnMap, 'drugCode'),
    drugName: getCellValue(row, columnMap, 'drugName'),
    feeRateValue: getCellValue(row, columnMap, 'feeRate'),
    quantityValue: getCellValue(row, columnMap, 'quantity'),
    unitPriceValue: getCellValue(row, columnMap, 'unitPrice'),
    prescriptionAmountValue: getCellValue(row, columnMap, 'prescriptionAmount'),
    settlementAmountValue: getCellValue(row, columnMap, 'settlementAmount'),
    note: getCellValue(row, columnMap, 'note'),
  });
}

function extractRowsFromSheet({
  rows,
  fileName,
  sheetName,
  detectedPharmaceuticalCompany,
  fieldAliases = COMMON_FIELD_ALIASES,
  templateId = 'default',
}) {
  const normalizedAliases = buildNormalizedAliases(fieldAliases);
  const { index: headerRowIndex, columnMap } = findHeaderRowIndex(
    rows,
    normalizedAliases,
  );

  if (headerRowIndex < 0) {
    return [];
  }

  const extractedRows = [];

  rows.slice(headerRowIndex + 1).forEach((row, rowOffset) => {
    if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
      return;
    }

    const record = buildRecordFromColumnMap({
      row,
      columnMap,
      fileName,
      sheetName,
      rowIndex: headerRowIndex + rowOffset + 1,
      templateId,
      detectedPharmaceuticalCompany,
    });

    if (shouldSkipRecord(record, row)) {
      return;
    }

    extractedRows.push(record);
  });

  return extractedRows;
}

function buildCompositeHeaders(
  rows = [],
  startRowIndex = 0,
  headerRowCount = 2,
) {
  const headerRows = rows.slice(startRowIndex, startRowIndex + headerRowCount);
  const maxColumnLength = headerRows.reduce(
    (max, row) => Math.max(max, Array.isArray(row) ? row.length : 0),
    0,
  );

  return Array.from({ length: maxColumnLength }, (_, columnIndex) => {
    const tokens = headerRows
      .map((row) => cleanText(row?.[columnIndex]))
      .filter(Boolean)
      .filter(
        (token, tokenIndex, array) => array.indexOf(token) === tokenIndex,
      );

    return tokens.join(' ');
  });
}

function sortRows(rows = []) {
  return [...rows].sort((left, right) => {
    return (
      left.pharmaceuticalCompanyName.localeCompare(
        right.pharmaceuticalCompanyName,
        'ko',
      ) ||
      left.customerName.localeCompare(right.customerName, 'ko') ||
      left.drugName.localeCompare(right.drugName, 'ko')
    );
  });
}

export {
  COMMON_FIELD_ALIASES,
  cleanText,
  normalizeHeader,
  parseNumber,
  normalizeRate,
  roundAmount,
  getFileExtension,
  guessPharmaceuticalCompanyName,
  normalizePharmaceuticalCompanyName,
  buildNormalizedAliases,
  buildColumnMap,
  findHeaderRowIndex,
  getCellValue,
  shouldSkipRecord,
  buildStandardRecord,
  buildRecordFromColumnMap,
  extractRowsFromSheet,
  buildCompositeHeaders,
  sortRows,
};
